import CategoryBoxIcon from "components/icons/CategoryBoxIcon"
import CategoryPhoneIcon from "components/icons/CategoryPhoneIcon"
import CategoryTagIcon from "components/icons/CategoryTagIcon"

/* ===============================
   WORK STATION
=============================== */
const LogoBox = <CategoryBoxIcon />
const LogoPhone = <CategoryPhoneIcon />
const LogoTag = <CategoryTagIcon />

export const workStation = {
  header: "WORK STATION",
  items: [
    {
      logo: LogoBox,
      title: "HUB 24",
      subtitle: "CRM, SIS, Ticket",
      link: "http://hub24.apollo.vn:10004/",
    },
    {
      logo: LogoPhone,
      title: "LMS",
      subtitle: "LMS",
      link: "https://tailored.apollo.edu.vn/login",
    },
    {
      logo: LogoTag,
      title: "WeLearn",
      subtitle: "We learn",
      link: "https://welearn.apollo.vn/login/index.php",
    },
  ],
}

/* ===============================
   DEFAULT LINKS
=============================== */
export const defaultLinks = {
  header: "LINKS",
  items: [
    {
      logo: LogoBox,
      title: "Teacher Drive",
      subtitle: "Teaching Materials",
      link: "https://drive.google.com/drive/u/0/folders/0AGpuZYv6pmTTUk9PVA?pli=1",
    },
    {
      logo: LogoBox,
      title: "Apollo Connect",
      subtitle: "Communication Channel",
      link: "https://sites.google.com/apollo.edu.vn/apollo-connect",
    },
    {
      logo: LogoBox,
      title: "Active Online Teacher Portal",
      subtitle: "Active Online Teacher Portal",
      link: "https://sites.google.com/apollo.edu.vn/active-teacher-portal/active-training?authuser=0",
    },
    {
      logo: LogoBox,
      title: "IELTS Portal",
      subtitle: "IELTS Portal",
      link: "https://sites.google.com/apollo.edu.vn/apollo-ielts/home",
    },
    {
      logo: LogoBox,
      title: "My Apollo Support Link",
      subtitle: "My Apollo Support Link",
      link: "https://docs.google.com/spreadsheets/d/1t_31p8T6QOtd4XrECpncVfYAHcCG-DCR8Yx7aCjPXJE/edit?usp=sharing",
    },
  ],
}

/* ===============================
   LXO ICONS (SVG)
=============================== */
const IconPayroll = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.74 4.503H6.02a.5.5 0 0 0 0 1h.25C5.5 6.24 4.57 7.11 3.84 8.08 3.07 9.11 2.52 10.25 2.52 11.46c0 1.02.24 1.79.64 2.37C4.08 15.13 5.9 15.49 8.02 15.49c2.12 0 3.93-.36 4.85-1.66.41-.58.64-1.35.64-2.37 0-1.21-.55-2.35-1.32-3.38-.73-.97-1.67-1.84-2.43-2.58h.25a.5.5 0 0 0 0-1h-.73l.93-1.82a1 1 0 0 0-.27-1.47A1 1 0 0 0 8.88.5H7.15a1 1 0 0 0-.98 1.5l.57 1.82Z"
      fill="white"
    />
  </svg>
)

const IconReportEmail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M14 3.33H2a.67.67 0 0 0-.67.67v8a.67.67 0 0 0 .67.67h12a.67.67 0 0 0 .67-.67v-8A.67.67 0 0 0 14 3.33ZM11.7 7.22 8.37 9.43a.67.67 0 0 1-.74 0L4.32 7.21a.67.67 0 1 1 .74-1.1l2.94 1.96 2.95-1.96a.67.67 0 0 1 .75 1.1Z"
      fill="white"
    />
  </svg>
)

const IconGuideline = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.22365 2.91406C1.27775 2.91406 0.5 3.69178 0.5 4.6377V11.3662C0.5 12.3121 1.27775 13.0898 2.22365 13.0898H9.59865C10.5446 13.0898 11.3223 12.3121 11.3223 11.3662V4.6377C11.3223 3.69178 10.5446 2.91406 9.59865 2.91406H2.22365ZM2.50295 5.00293C2.63488 5.00344 2.76126 5.05608 2.85456 5.14937C2.94785 5.24266 3.00049 5.36904 3.001 5.50098V8C3.00126 8.06566 2.98858 8.13073 2.96369 8.19149C2.9388 8.25225 2.90218 8.30752 2.85593 8.35413C2.80969 8.40074 2.75471 8.43778 2.69414 8.46315C2.63358 8.48851 2.56861 8.5017 2.50295 8.50195C2.43696 8.50221 2.37157 8.4894 2.31056 8.46427C2.24954 8.43914 2.1941 8.40217 2.14744 8.35551C2.10078 8.30885 2.06382 8.25341 2.03868 8.19239C2.01355 8.13138 2.00074 8.06599 2.001 8V5.50098C2.00126 5.43532 2.01444 5.37035 2.03981 5.30978C2.06517 5.24922 2.10222 5.19424 2.14883 5.148C2.19544 5.10175 2.2507 5.06513 2.31146 5.04024C2.37222 5.01535 2.43729 5.00267 2.50295 5.00293Z"
      fill="white"
    />
    <path
      d="M14.3096 4.49494C14.1917 4.50384 14.0726 4.53497 13.9668 4.59162L12.3203 5.47443V10.7908L14.0254 11.4422C14.4481 11.6038 14.8889 11.4015 15.126 11.1395C15.3631 10.8774 15.498 10.5486 15.498 10.1834V5.82404C15.498 5.45002 15.3604 5.12161 15.1221 4.85334C15.0028 4.7192 14.8492 4.59848 14.6455 4.53205C14.5436 4.49883 14.4274 4.48603 14.3096 4.49494Z"
      fill="white"
    />
  </svg>
)

const IconScheduling = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3847_6206)">
      <path
        d="M15 3.46508V5.50008H1V3.46508C1.00512 3.07205 1.16591 2.69709 1.44711 2.42245C1.72831 2.14782 2.10696 1.99592 2.5 2.00008H3.5V3.00008C3.5 3.39791 3.65804 3.77944 3.93934 4.06074C4.22064 4.34205 4.60218 4.50008 5 4.50008C5.39782 4.50008 5.77936 4.34205 6.06066 4.06074C6.34196 3.77944 6.5 3.39791 6.5 3.00008V2.00008H9.5V3.00008C9.5 3.39791 9.65804 3.77944 9.93934 4.06074C10.2206 4.34205 10.6022 4.50008 11 4.50008C11.3978 4.50008 11.7794 4.34205 12.0607 4.06074C12.342 3.77944 12.5 3.39791 12.5 3.00008V2.00008H13.5C13.893 1.99592 14.2717 2.14782 14.5529 2.42245C14.8341 2.69709 14.9949 3.07205 15 3.46508Z"
        fill="white"
      />
      <path
        d="M1 6.5V14.535C1.00512 14.928 1.16591 15.303 1.44711 15.5776C1.72831 15.8523 2.10696 16.0042 2.5 16H13.5C13.893 16.0042 14.2717 15.8523 14.5529 15.5776C14.8341 15.303 14.9949 14.928 15 14.535V6.5H1ZM5.5 13.5C5.49962 13.6325 5.44682 13.7594 5.35313 13.8531C5.25945 13.9468 5.13249 13.9996 5 14H4C3.86751 13.9996 3.74055 13.9468 3.64687 13.8531C3.55318 13.7594 3.50038 13.6325 3.5 13.5V12.5C3.50038 12.3675 3.55318 12.2406 3.64687 12.1469C3.74055 12.0532 3.86751 12.0004 4 12H5C5.13249 12.0004 5.25945 12.0532 5.35313 12.1469C5.44682 12.2406 5.49962 12.3675 5.5 12.5V13.5ZM5.5 10C5.49962 10.1325 5.44682 10.2594 5.35313 10.3531C5.25945 10.4468 5.13249 10.4996 5 10.5H4C3.86751 10.4996 3.74055 10.4468 3.64687 10.3531C3.55318 10.2594 3.50038 10.1325 3.5 10V9C3.50038 8.86751 3.55318 8.74056 3.64687 8.64687C3.74055 8.55318 3.86751 8.50038 4 8.5H5C5.13249 8.50038 5.25945 8.55318 5.35313 8.64687C5.44682 8.74056 5.49962 8.86751 5.5 9V10ZM9 13.5C8.99962 13.6325 8.94682 13.7594 8.85313 13.8531C8.75944 13.9468 8.63249 13.9996 8.5 14H7.5C7.36751 13.9996 7.24055 13.9468 7.14687 13.8531C7.05318 13.7594 7.00038 13.6325 7 13.5V12.5C7.00038 12.3675 7.05318 12.2406 7.14687 12.1469C7.24055 12.0532 7.36751 12.0004 7.5 12H8.5C8.63249 12.0004 8.75944 12.0532 8.85313 12.1469C8.94682 12.2406 8.99962 12.3675 9 12.5V13.5ZM9 10C8.99962 10.1325 8.94682 10.2594 8.85313 10.3531C8.75944 10.4468 8.63249 10.4996 8.5 10.5H7.5C7.36751 10.4996 7.24055 10.4468 7.14687 10.3531C7.05318 10.2594 7.00038 10.1325 7 10V9C7.00038 8.86751 7.05318 8.74056 7.14687 8.64687C7.24055 8.55318 7.36751 8.50038 7.5 8.5H8.5C8.63249 8.50038 8.75944 8.55318 8.85313 8.64687C8.94682 8.74056 8.99962 8.86751 9 9V10ZM12.5 10C12.4996 10.1325 12.4468 10.2594 12.3531 10.3531C12.2594 10.4468 12.1325 10.4996 12 10.5H11C10.8675 10.4996 10.7406 10.4468 10.6469 10.3531C10.5532 10.2594 10.5004 10.1325 10.5 10V9C10.5004 8.86751 10.5532 8.74056 10.6469 8.64687C10.7406 8.55318 10.8675 8.50038 11 8.5H12C12.1325 8.50038 12.2594 8.55318 12.3531 8.64687C12.4468 8.74056 12.4996 8.86751 12.5 9V10Z"
        fill="white"
      />
      <path
        d="M5.5 2V3C5.5 3.13261 5.44732 3.25979 5.35355 3.35355C5.25979 3.44732 5.13261 3.5 5 3.5C4.86739 3.5 4.74021 3.44732 4.64645 3.35355C4.55268 3.25979 4.5 3.13261 4.5 3V2C4.5 1.86739 4.55268 1.74021 4.64645 1.64645C4.74021 1.55268 4.86739 1.5 5 1.5C5.13261 1.5 5.25979 1.55268 5.35355 1.64645C5.44732 1.74021 5.5 1.86739 5.5 2Z"
        fill="white"
      />
      <path
        d="M11.5 2V3C11.5 3.13261 11.4473 3.25979 11.3536 3.35355C11.2598 3.44732 11.1326 3.5 11 3.5C10.8674 3.5 10.7402 3.44732 10.6464 3.35355C10.5527 3.25979 10.5 3.13261 10.5 3V2C10.5 1.86739 10.5527 1.74021 10.6464 1.64645C10.7402 1.55268 10.8674 1.5 11 1.5C11.1326 1.5 11.2598 1.55268 11.3536 1.64645C11.4473 1.74021 11.5 1.86739 11.5 2Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3847_6206">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const IconActiveSchedule = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3847_6218)">
      <path
        d="M9.5 0H1.83333C0.82 0 0 0.82 0 1.83333V12.1667C0 13.18 0.82 14 1.83333 14H7.26667C6.70667 13.1133 6.33333 12.0667 6.33333 10.8667V9.24C6.23333 9.3 6.12 9.33333 6 9.33333H2.66667C2.3 9.33333 2 9.03333 2 8.66667C2 8.3 2.3 8 2.66667 8H6C6.12667 8 6.24 8.03333 6.34 8.09333C6.36667 7.52667 6.63333 7.00667 7.05333 6.66667H2.66667C2.3 6.66667 2 6.36667 2 6C2 5.63333 2.3 5.33333 2.66667 5.33333H8.66667C8.94667 5.33333 9.18667 5.50667 9.28667 5.75333L11.1867 5.10667C11.2333 5.08667 11.28 5.07333 11.3333 5.06667V1.83333C11.3333 0.82 10.5133 0 9.5 0ZM5.33333 4H2.66667C2.3 4 2 3.7 2 3.33333C2 2.96667 2.3 2.66667 2.66667 2.66667H5.33333C5.7 2.66667 6 2.96667 6 3.33333C6 3.7 5.7 4 5.33333 4Z"
        fill="white"
      />
      <path
        d="M15.5461 7.5582L12.0461 6.36753C11.9067 6.3202 11.7554 6.3202 11.6161 6.36753L8.11606 7.5582C7.84606 7.6502 7.66406 7.9042 7.66406 8.18953V10.8682C7.66406 14.2462 11.4101 15.8782 11.5694 15.9462C11.6534 15.9815 11.7427 15.9989 11.8314 15.9989C11.9201 15.9989 12.0094 15.9815 12.0927 15.9455C12.2521 15.8775 15.9981 14.2462 15.9981 10.8682V8.18953C15.9981 7.90353 15.8167 7.6502 15.5461 7.5582ZM14.1981 10.0655L12.1981 12.7322C12.0821 12.8869 11.9054 12.9835 11.7121 12.9969C11.6961 12.9982 11.6801 12.9989 11.6647 12.9989C11.4881 12.9989 11.3187 12.9295 11.1934 12.8035L9.86006 11.4702C9.5994 11.2095 9.5994 10.7882 9.86006 10.5275C10.1207 10.2669 10.5421 10.2669 10.8027 10.5275L11.5927 11.3175L13.1314 9.26553C13.3521 8.97153 13.7701 8.91086 14.0641 9.1322C14.3594 9.35286 14.4194 9.77086 14.1981 10.0655Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3847_6218">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const IconTeacherRecruit = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3847_6237)">
      <path
        d="M15.6578 3.22285C15.3569 1.8641 14.0397 0.619415 12.6772 0.35504C11.8472 0.189102 9.53156 -0.0158976 8 0.000977442C6.46844 -0.0158976 4.15281 0.189102 3.32281 0.35504C1.96031 0.619415 0.643125 1.8641 0.342187 3.22285C0.170937 4.04785 0.0025 5.17035 0 6.70254C0.0025 8.23473 0.170937 9.35692 0.342187 10.1819C0.643125 11.5407 1.96031 12.7854 3.32281 13.0497C3.77094 13.1394 4.65219 13.2404 5.60938 13.3116C5.71781 13.4819 5.83531 13.6632 5.9625 13.8554C6.47031 14.6244 6.85906 15.1604 7.15344 15.5338C7.64344 16.1554 8.35688 16.1554 8.84688 15.5338C9.14125 15.1604 9.52969 14.6244 10.0378 13.8554C10.165 13.6629 10.2822 13.4819 10.3909 13.3116C11.3481 13.2404 12.2294 13.1394 12.6778 13.0497C14.0403 12.7854 15.3575 11.5407 15.6584 10.1819C15.8297 9.35692 15.9981 8.23473 16.0006 6.70254C15.9981 5.17035 15.8297 4.04817 15.6584 3.22317L15.6578 3.22285ZM8.88344 11.3479C8.84969 11.5382 8.67719 11.7107 8.48687 11.7444C8.37156 11.7635 8.21438 11.7816 7.99969 11.7819C7.78531 11.7819 7.62812 11.7638 7.5125 11.7444C7.32219 11.7107 7.14969 11.5382 7.11594 11.3479C7.09688 11.2325 7.07875 11.0754 7.07844 10.8607C7.07844 10.6463 7.09656 10.4891 7.11594 10.3735C7.14969 10.1832 7.32219 10.0107 7.5125 9.97692C7.62781 9.95785 7.785 9.93973 7.99969 9.93941C8.21406 9.93941 8.37125 9.95754 8.48687 9.97692C8.67719 10.0107 8.84969 10.1832 8.88344 10.3735C8.9025 10.4888 8.92063 10.646 8.92094 10.8607C8.92094 11.075 8.90281 11.2322 8.88344 11.3479ZM10.7859 6.22941C10.5447 6.57066 10.1831 6.88223 9.64812 7.20941C8.97094 7.62691 8.8625 7.79848 8.8625 8.13441V8.26723C8.8625 8.74348 8.475 9.13098 7.99875 9.13098C7.5225 9.13098 7.135 8.74348 7.135 8.26723V7.95941C7.135 7.56316 7.23406 7.22691 7.43781 6.9316C7.63531 6.64535 7.93125 6.39098 8.37031 6.13004C9.17938 5.6541 9.3275 5.38692 9.3275 5.03223C9.3275 4.5866 8.94781 4.29848 8.36063 4.29848C7.71688 4.29848 7.29781 4.59098 7.115 5.16817C6.99437 5.54879 6.64187 5.80442 6.23812 5.80442C6.21562 5.80442 6.19313 5.80348 6.17063 5.80192C5.88563 5.78129 5.63031 5.63348 5.47031 5.39629C5.31188 5.1616 5.27031 4.87317 5.35625 4.60473C5.55312 3.99098 5.93063 3.48035 6.44781 3.12785C6.97156 2.77098 7.63312 2.58254 8.36031 2.58254C9.0875 2.58254 9.81656 2.82348 10.3341 3.26098C10.8666 3.71129 11.16 4.33191 11.16 5.0091C11.16 5.4741 11.0378 5.87348 10.7859 6.22941Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3847_6237">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const IconFinalPackage = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3847_6246)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 7.5C14.6046 7.5 15.5 6.60458 15.5 5.5V2.5C15.5 1.39543 14.6046 0.5 13.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V5.5C0.5 6.60458 1.39543 7.5 2.5 7.5H13.5ZM13.25 4C13.25 4.27615 13.0261 4.5 12.75 4.5H7.25C6.97385 4.5 6.75 4.27615 6.75 4C6.75 3.72385 6.97385 3.5 7.25 3.5H12.75C13.0261 3.5 13.25 3.72385 13.25 4ZM5.57748 2.87215C5.78615 3.053 5.8087 3.36878 5.62785 3.57748L4.32785 5.07748C4.23165 5.18848 4.0915 5.25155 3.94462 5.24998C3.79772 5.2484 3.65898 5.1823 3.5652 5.06925L2.8652 4.2255C2.68888 4.01298 2.71822 3.69775 2.93075 3.52145C3.14327 3.34513 3.4585 3.37447 3.6348 3.587L3.95832 3.97695L4.87215 2.92252C5.053 2.71385 5.36878 2.6913 5.57748 2.87215Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 15.5C14.6046 15.5 15.5 14.6046 15.5 13.5V10.5C15.5 9.39542 14.6046 8.5 13.5 8.5H2.5C1.39543 8.5 0.5 9.39542 0.5 10.5V13.5C0.5 14.6046 1.39543 15.5 2.5 15.5H13.5ZM12.75 12.5C13.0261 12.5 13.25 12.2761 13.25 12C13.25 11.7239 13.0261 11.5 12.75 11.5H7.25C6.97385 11.5 6.75 11.7239 6.75 12C6.75 12.2761 6.97385 12.5 7.25 12.5H12.75ZM5.62785 11.5775C5.8087 11.3688 5.78615 11.053 5.57748 10.8722C5.36878 10.6913 5.053 10.7139 4.87215 10.9225L3.95832 11.9769L3.6348 11.587C3.4585 11.3745 3.14327 11.3451 2.93075 11.5215C2.71822 11.6978 2.68888 12.013 2.8652 12.2255L3.5652 13.0693C3.65898 13.1823 3.79772 13.2484 3.94462 13.25C4.0915 13.2516 4.23165 13.1885 4.32785 13.0775L5.62785 11.5775Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3847_6246">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

/* ===============================
   LXO LINKS
=============================== */
export const LXOLinks = {
  header: "LINKS",
  items: [
    {
      logo: IconPayroll,
      title: "Payroll Checklist & Guidelines",
      link: "https://docs.google.com/document/d/1_lSxrYCiMAbbfgo8O1_g9049XFCIqGylyfbtMzggJqs/edit?tab=t.0#heading=h.ebaom03t455w",
    },
    {
      logo: IconReportEmail,
      title: "Report Email Templates",
      link: "https://docs.google.com/document/d/1efar9i74TOui1yvLD3cicRdR3KD6FZuW3dAs02XO1G4/edit?tab=t.0#heading=h.km3t4yloqx6b",
    },
    {
      logo: IconGuideline,
      title: "Guideline for Recording",
      link: "https://docs.google.com/document/d/1T_pznK2XUL9apNGHpDtJDcFG9VdDNPdLypX9YKRfBtM/edit?tab=t.0",
    },
    {
      logo: IconScheduling,
      title: "Scheduling Guidelines",
      link: "https://docs.google.com/spreadsheets/d/177IGvU2uRsEE4GnQ5zlbQIsN8tVaUrnQVYIGTXICsPc/edit?gid=464094580#gid=464094580",
    },
    {
      logo: IconTeacherRecruit,
      title: "Teacher Recruitment Submission",
      link: "https://docs.google.com/forms/d/e/1FAIpQLSeAU5ogBZT4c0mzDvilryO30dPHowh781LQRU-8sJYlyNArgw/viewform",
    },
    {
      logo: IconFinalPackage,
      title: "Final Package Confirmation Form",
      link: "https://docs.google.com/forms/d/e/1FAIpQLSeyoMmhoCN1UrjIko7X3EdiZG7kbxLQbYUgmyn9kkvs79DiUA/viewform",
    },
  ],
}

/* ===============================
   OTHER ROLES — LINKS BLOCK IMAGE
   Điền URL ảnh vào đây để thay cho danh sách link phía trên
   (dùng cho các role không phải Teacher/LXO/LX/Procurement)
=============================== */
export const otherRoleLinksImageUrl = "https://demo-lesson.sgp1.digitaloceanspaces.com/post.%20visual.png"

export const otherRoleLinks = {
  header: "LINKS",
  items: [
    {
      logo: IconPayroll,
      title: "Payroll Checklist & Guidelines",
      link: "https://docs.google.com/document/d/1_lSxrYCiMAbbfgo8O1_g9049XFCIqGylyfbtMzggJqs/edit?tab=t.0#heading=h.ebaom03t455w",
    },
    {
      logo: IconReportEmail,
      title: "Report Email templates",
      link: "https://docs.google.com/document/d/1efar9i74TOui1yvLD3cicRdR3KD6FZuW3dAs02XO1G4/edit?tab=t.0#heading=h.km3t4yloqx6b",
    },
    {
      logo: IconGuideline,
      title: "Guideline for recording",
      link: "https://docs.google.com/document/d/1T_pznK2XUL9apNGHpDtJDcFG9VdDNPdLypX9YKRfBtM/edit?tab=t.0",
    },
    {
      logo: IconScheduling,
      title: "Scheduling Guidelines",
      link: "https://docs.google.com/spreadsheets/d/177IGvU2uRsEE4GnQ5zlbQIsN8tVaUrnQVYIGTXICsPc/edit?gid=464094580#gid=464094580",
    },

    {
      logo: IconTeacherRecruit,
      title: "Teacher recruitment submission",
      link: "https://docs.google.com/forms/d/e/1FAIpQLSeAU5ogBZT4c0mzDvilryO30dPHowh781LQRU-8sJYlyNArgw/viewform",
    },
    {
      logo: IconTeacherRecruit, // <- bạn cần icon tương ứng hoặc tạm dùng IconGuideline/IconScheduling
      title: "Teacher Request & New Hires Tracker",
      link: "https://docs.google.com/spreadsheets/d/1_n0vSTiUBVoq0nOd52sUEtDXavvMGqsNjw9ZhgNIu5I/edit?resourcekey=&gid=585528657#gid=585528657",
    },
    {
      logo: IconFinalPackage,
      title: "Final Package Confirmation Form",
      link: "https://docs.google.com/forms/d/e/1FAIpQLSeyoMmhoCN1UrjIko7X3EdiZG7kbxLQbYUgmyn9kkvs79DiUA/viewform",
    },
  ],
}
